module.exports = __webpack_public_path__ + "static/media/Residences-Hero.e0e6f715.jpg";